import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import useTranslator from "../../../hooks/useTranslator";

const MetricBox = ({ label, value, color, isLoading = false }) => (
  <div className="bd-metric-box">
    <div className="bd-metric-label" style={color ? { color } : {}}>{label}</div>
    <div className="bd-metric-value" style={color ? { color } : {}}>
      {isLoading
        ? <span className="db-shimmer" style={{ height: 28, width: 80, display: "block" }} />
        : (value ?? "—")
      }
    </div>
  </div>
);

const ProcessFlow = ({ data = {}, isLoading = false }) => {
  const { _t } = useTranslator();
  const receiving_data = data?.receiving ?? [];
  const processing_flow = data?.processing_flow ?? [];
  return (
    <div className="bd-left-col">
      <DashboardCard title={_t("receiving", "Receiving")}>
        <div className="bd-receiving-row">
          <MetricBox label={_t("case_entered", "CASE ENTERED")}  value={receiving_data?.total_cases_entered?.toLocaleString() ?? 0}  color="#ee7225" isLoading={isLoading} />
          <MetricBox label={_t("case_accepted", "CASE ACCEPTED")} value={receiving_data?.total_cases_accepted?.toLocaleString() ?? 0} color="#25aa91" isLoading={isLoading} />
          <MetricBox label={_t("case_rejected", "CASE REJECTED")} value={receiving_data?.total_cases_rejected?.toLocaleString() ?? 0} color="#e53935" isLoading={isLoading} />
        </div>
      </DashboardCard>

      <DashboardCard title={_t("processing_flow", "Processing Flow")}>
        <div className="bd-processing-grid">
          <MetricBox label={_t("case_sorted", "Case Sorted")}           value={`${processing_flow?.total_cases_sorted?.toLocaleString() ?? "0"}`}        isLoading={isLoading} />
          <MetricBox label={_t("case_processed", "Case Processed")}        value={`${processing_flow?.total_cases_processed?.toLocaleString() ?? "0"}`}     isLoading={isLoading} />
          <MetricBox label={_t("kg_night_taken_off", "Kg Night Taken Off")}    value={`${processing_flow?.kg_night_taken_off?.toLocaleString() ?? "0"} kg`}     isLoading={isLoading} />
          <MetricBox label={_t("boxes_packed_fruit", "Boxes Packed Fruit")}    value={`${processing_flow?.boxes_packed_fruit?.toLocaleString() ?? "0"}`}        isLoading={isLoading} />
          <MetricBox label={_t("boxes_packed_rework", "Boxes Packed (Rework)")} value={`${processing_flow?.boxes_packed_rework?.toLocaleString() ?? "0"}`}       isLoading={isLoading} />
          <MetricBox label={_t("boxes_packed_paste", "Boxes Packed Paste")}    value={`${processing_flow?.boxes_packed_paste?.toLocaleString() ?? "0"}`}        isLoading={isLoading} />
        </div>
      </DashboardCard>
    </div>
  );
};

export default ProcessFlow;
